import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router';
import { useSampleMeta } from '../hooks/useSampleMeta';
import { LoadingDisplay } from '../components/LoadingDisplay.tsx';
import { ErrorDisplay } from '../components/ErrorDisplay.tsx';
import { useViewers } from '../hooks/useViewers';
import { BUILTIN_VIEWER_ID } from '../utils/viewers';

export default function SamplePermalink() {
  const { uuid } = useParams<{ uuid: string }>();
  const { sampleMeta, isLoading, error } = useSampleMeta(uuid);
  const { primaryUrl, loaded, defaultViewerId } = useViewers();
  const viewersReady = loaded || defaultViewerId === BUILTIN_VIEWER_ID;

  const redirectUrl = useMemo(() => {
    if (!sampleMeta || !viewersReady) return null;
    const { eval_set_id, filename, id, epoch, uuid: sampleUuid } = sampleMeta;
    return primaryUrl(
      {
        level: 'sample',
        evalSetId: eval_set_id,
        logFile: filename,
        sampleId: id,
        epoch,
        sampleUuid,
      },
      { redirect: true }
    );
  }, [sampleMeta, viewersReady, primaryUrl]);

  useEffect(() => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  if (isLoading) {
    return <LoadingDisplay message="Loading sample..." subtitle={uuid} />;
  }

  if (error) {
    return <ErrorDisplay message={error.message} />;
  }

  if (sampleMeta) {
    return (
      <LoadingDisplay message="Redirecting to sample..." subtitle={uuid} />
    );
  }

  return null;
}
